import React from 'react';
import { useParams, Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { CMSArticleSection } from '../components/CMSArticleSection';
import { ArrowLeft } from 'lucide-react';

const NEWS_PAGES = {
  'hq-events':          { slug: 'hq-events',          eyebrow: 'News & Events', title: 'HQ',    accent: 'Events',      subtitle: "Flagship events organised by EWRF's Kuala Lumpur headquarters." },
  'branch-activities':  { slug: 'branch-activities',  eyebrow: 'News & Events', title: 'Branch',accent: 'Activities',  subtitle: 'Highlights from EWRF branches across Malaysia.' },
  'media-coverage':     { slug: 'media-coverage',     eyebrow: 'News & Events', title: 'Media', accent: 'Coverage',    subtitle: "Press articles and broadcast features about EWRF's work.", variant: 'media' },
  'media-statement':    { slug: 'media-statements',   eyebrow: 'News & Events', title: 'News', accent: 'Releases',  subtitle: 'Official news releases and press statements from EWRF leadership.' },
  'newsletter':         { slug: 'newsletter',          eyebrow: 'News & Events', title: 'News', accent: 'Letter',    subtitle: 'Monthly EWRF newsletters — stories, programme updates and community highlights.' },
};

const NewsPage = () => {
  const { section } = useParams();
  const cfg = NEWS_PAGES[section];
  if (!cfg) return <div className="min-h-screen flex items-center justify-center">Page not found</div>;
  return (
    <div className="min-h-screen bg-white" data-testid={`news-page-${section}`}>
      <Header />
      <div className="max-w-7xl mx-auto px-4 pt-6">
        <Link to="/" className="inline-flex items-center gap-2 text-[#1565C0] hover:text-orange-600 text-sm font-bold">
          <ArrowLeft className="w-4 h-4" /> Back to Home
        </Link>
      </div>
      <CMSArticleSection
        anchor={cfg.slug}
        slug={cfg.slug}
        eyebrow={cfg.eyebrow}
        title={cfg.title}
        accent={cfg.accent}
        subtitle={cfg.subtitle}
        variant={cfg.variant || (section === 'newsletter' ? 'pdf' : 'default')}
      />
      <Footer />
    </div>
  );
};

export default NewsPage;
